export const useUserStore = defineStore('userStore', {
  state: () => ({
    user: {},
    friendToken: '',
    shareLink: '',
    phoneNumber: null,
    prizeThreshold: 1,
    numberOfPrizes: 1,
    invitees: null,
    discountCodes: null,
    isFinishGame: false,
    isShowNavbarItems: false,
    currentCharacter: localStorage.getItem(
      `taline-mini-game-${useRuntimeConfig().public.GAME_VALUE}-user-character`,
    ),
  }),
  getters: {},
  actions: {
    async profile() {
      const api = useApi()
      const response = await api.getUser()
      const getInvitees = await api.invitees()
      const getDiscountCodes = await api.getDiscountCode()
      this.invitees = getInvitees
      this.user = response
      this.discountCodes = getDiscountCodes

      switch (response.userGame.prizeThreshold) {
        case 'zero':
          localStorage.setItem('current-level', 1)
          this.prizeThreshold = 'اول'
          this.numberOfPrizes = 1
          break
        case 'one':
          localStorage.setItem('current-level', 2)
          this.prizeThreshold = 'دوم'
          this.numberOfPrizes = 2
          this.isFinishGame = true
          break
        case 'two':
          localStorage.setItem('current-level', 3)
          this.prizeThreshold = 'سوم'
          this.numberOfPrizes = 3
          break
        case 'three':
          localStorage.setItem('current-level', 3)
          this.prizeThreshold = 'سوم'
          this.numberOfPrizes = 3
          this.isFinishGame = true
          break
        default:
          this.prizeThreshold = 'اول'
          this.numberOfPrizes = 1
          break
      }
    },

    setCharacter(character) {
      const RuntimeConfig = useRuntimeConfig()
      this.currentCharacter = character
      localStorage.setItem(
        `taline-mini-game-${RuntimeConfig.public.GAME_VALUE}-user-character`,
        character,
      )
    },
  },
})
